var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#A5A821"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_383_718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_383_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 18.0003C6.96667 18.0003 6.65267 17.8699 6.39133 17.609C6.13044 17.3477 6 17.0337 6 16.667V7.33366C6 6.96699 6.13044 6.65299 6.39133 6.39166C6.65267 6.13077 6.96667 6.00033 7.33333 6.00033H10.1333C10.2778 5.60033 10.5196 5.2781 10.8587 5.03366C11.1973 4.78921 11.5778 4.66699 12 4.66699C12.4222 4.66699 12.8029 4.78921 13.142 5.03366C13.4807 5.2781 13.7222 5.60033 13.8667 6.00033H16.6667C17.0333 6.00033 17.3473 6.13077 17.6087 6.39166C17.8696 6.65299 18 6.96699 18 7.33366V16.667C18 17.0337 17.8696 17.3477 17.6087 17.609C17.3473 17.8699 17.0333 18.0003 16.6667 18.0003H7.33333ZM7.33333 16.667H16.6667V7.33366H7.33333V16.667ZM8.66667 15.3337H13.3333V14.0003H8.66667V15.3337ZM8.66667 12.667H15.3333V11.3337H8.66667V12.667ZM8.66667 10.0003H15.3333V8.66699H8.66667V10.0003ZM12 6.83366C12.1444 6.83366 12.264 6.78633 12.3587 6.69166C12.4529 6.59744 12.5 6.4781 12.5 6.33366C12.5 6.18921 12.4529 6.06966 12.3587 5.97499C12.264 5.88077 12.1444 5.83366 12 5.83366C11.8556 5.83366 11.7362 5.88077 11.642 5.97499C11.5473 6.06966 11.5 6.18921 11.5 6.33366C11.5 6.4781 11.5473 6.59744 11.642 6.69166C11.7362 6.78633 11.8556 6.83366 12 6.83366Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.875fdffd93f258bc1f60bb88c249a0fb.svg";
export { ForwardRef as ReactComponent };